import React, { useContext } from "react";
import { AppContext } from "../../contexts/AppContext";
import ModelsManager from "../../components/Models/ModelsManager";

/**
 * Client-level model registry: the client's own models are editable, admin-level models are
 * visible and read-only.
 */
export const Models = () => {
  const { selectedClient } = useContext(AppContext);

  return (
    <ModelsManager
      scope="client"
      clientId={selectedClient?.public_id ?? selectedClient?.id ?? null}
    />
  );
};

export default Models;
